import PropTypes from 'prop-types';
import React from 'react';

import getStructuredDataAttributes from '../lib/StructuredDataAttributes';

const JsonLdOrganization = ({ description }) => {
  const generateJsonString = () => {
    const properties = getStructuredDataAttributes();

    return {
      '@context': 'https://schema.org/',
      '@type': 'RealEstateAgent',
      name: properties.name,
      description,
      url: properties.url,
      logo: properties.logo,
      image: properties.image,
      email: properties.email,
      telephone: properties.telephone,
      address: properties.address,
      priceRange: properties.priceRange,
      sameAs: properties.sameAs,
      aggregateRating: properties.aggregateRating
    };
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(generateJsonString())
      }}
    />
  );
};

JsonLdOrganization.propTypes = {
  description: PropTypes.string
};
JsonLdOrganization.defaultProps = {
  description: ''
};

export default JsonLdOrganization;
